// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Apollo = require("./bindings/Apollo.bs.js");
var Relude_Map = require("relude/src/Relude_Map.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var CommonTypes = require("./types/CommonTypes.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Client = require("@apollo/client");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var CommonTypes_Jwt = require("./types/CommonTypes_Jwt.bs.js");
var Relude_Function = require("relude/src/Relude_Function.bs.js");
var Cache = require("@apollo/client/cache");
var Utilities = require("@apollo/client/utilities");
var Context = require("@apollo/client/link/context");

var cache = new Cache.InMemoryCache();

function make(qwickClientType, qwickClientVersion, authorization) {
  var partial_arg = CommonTypes.QwickClientVersion.toString(qwickClientVersion);
  var partial_arg$1 = CommonTypes.QwickClientType.toString(qwickClientType);
  var partial_arg$2 = Relude_Option.map(CommonTypes_Jwt.toAuthHeader, authorization);
  return function (param) {
    var tmp = {
      "X-qwick-client-type": partial_arg$1,
      "X-qwick-client-version": partial_arg
    };
    if (partial_arg$2 !== undefined) {
      tmp.Authorization = Caml_option.valFromOption(partial_arg$2);
    }
    return tmp;
  };
}

function headerContextLink(qwickClientType, qwickClientVersion, authorization) {
  return Context.setContext(function (param) {
              return {
                      headers: make(qwickClientType, qwickClientVersion, authorization)(undefined)
                    };
            });
}

function httpLink(uri) {
  return Curry._7(Apollo.Link.Upload.make, uri, undefined, undefined, undefined, undefined, undefined, undefined);
}

function webSocketLink(apiUrl, qwickClientType, qwickClientVersion, authorization) {
  return Curry._4(Apollo.Link.$$WebSocket.make, apiUrl.replace(new RegExp("^http"), "ws"), true, Caml_option.some(make(qwickClientType, qwickClientVersion, authorization)(undefined)), undefined);
}

function webSocketHttpLink(apiUrl, qwickClientType, qwickClientVersion, authToken) {
  return Client.ApolloLink.split((function (operation) {
                var operationDefinition = Utilities.getMainDefinition(operation.query);
                if (operationDefinition.kind === "OperationDefinition") {
                  return operationDefinition.operation === "subscription";
                } else {
                  return false;
                }
              }), webSocketLink(apiUrl, qwickClientType, qwickClientVersion, authToken), httpLink(apiUrl));
}

function compare(param) {
  var a = param[0];
  if (a === undefined) {
    if (param[1] !== undefined) {
      return "greater_than";
    } else {
      return "equal_to";
    }
  }
  var b = param[1];
  if (b !== undefined) {
    return Curry._2(CommonTypes_Jwt.compare, Caml_option.valFromOption(a), Caml_option.valFromOption(b));
  } else {
    return "less_than";
  }
}

function eq(param) {
  return Relude_Globals.$great$great(compare, (function (param) {
                return "equal_to" === param;
              }), param);
}

function compare$1(param, param$1) {
  return Relude_Function.curry2(compare, param, param$1);
}

function eq$1(param, param$1) {
  return Relude_Function.curry2(eq, param, param$1);
}

var OptionalJwtMap = Relude_Map.WithOrd({
      eq: eq$1,
      compare: compare$1
    });

var apolloClientCache = {
  contents: Curry._1(OptionalJwtMap.make, undefined)
};

function make$1(apiUrl, qwickClientType, qwickClientVersion, maybeToken) {
  return Relude_Option.getOrElseLazy((function (param) {
                var tmp;
                var exit = 0;
                if (typeof qwickClientType === "number" && qwickClientType === 6) {
                  tmp = headerContextLink(qwickClientType, qwickClientVersion, maybeToken);
                } else {
                  exit = 1;
                }
                if (exit === 1) {
                  tmp = Client.ApolloLink.from([
                        headerContextLink(qwickClientType, qwickClientVersion, maybeToken),
                        webSocketHttpLink(apiUrl, qwickClientType, qwickClientVersion, maybeToken)
                      ]);
                }
                var client = Apollo.Client.make(cache, undefined, Caml_option.some(Curry._4(Apollo.Client.Options.DefaultOptions.make, Caml_option.some(Curry._1(Apollo.Client.Options.DefaultOptions.Options.make, /* NoCache */4)), Caml_option.some(Curry._1(Apollo.Client.Options.DefaultOptions.Options.make, /* NoCache */4)), Caml_option.some(Curry._1(Apollo.Client.Options.DefaultOptions.Options.make, /* NoCache */4)), undefined)), Caml_option.some(make(qwickClientType, qwickClientVersion, maybeToken)(undefined)), tmp, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
                apolloClientCache.contents = Curry._3(OptionalJwtMap.set, maybeToken, client, apolloClientCache.contents);
                return client;
              }), Curry._2(OptionalJwtMap.get, maybeToken, apolloClientCache.contents));
}

exports.make = make$1;
/* cache Not a pure module */
